import styled from 'styled-components';
import { TooltipTrigger } from '@arcadiapower/design-system';

// Figma "Container": surface-secondary fill, rounded-lg, 40px padding.
export const IntroBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 40px;
  border-radius: 8px;
  background-color: var(--surface-secondary);
`;

export const CapturedDataTrigger = styled(TooltipTrigger)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border-radius: 4px;

  &:focus-visible {
    outline: 2px solid var(--focus-ring);
    outline-offset: 2px;
  }
`;

export const TooltipBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* Preferred width from the design, capped by the iframe viewport so a
     narrow embed doesn't scroll the tooltip off the side. */
  width: min(340px, calc(100vw - 32px));
  max-width: 340px;
  padding: 4px;
  text-align: left;
  color: var(--foreground-inverse);
`;

// Same glyph as Shrike's InfoCircleInverted (viewBox 0 0 16, scale 2 → 16px).
// Main renders it in Shrike blue; Figma now specifies the secondary foreground.
export const CapturedDataIcon = styled.svg.attrs({
  'aria-hidden': true,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
})`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: var(--foreground-secondary);
`;

// The header is pulled up by a negative margin, so this divider's height is load
// bearing: without it the search section overlaps the copy above.
export const Divider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 40px 0;
`;

export const DividerLine = styled.hr.attrs({ 'aria-hidden': true })`
  width: 100%;
  height: 1px;
  background-color: var(--border-primary);
  border: none;
`;
